export default __webpack_public_path__ + "static/media/lightbulb.9f91ca6e.svg";